import { TableConfig } from '../../../components/table/Table';
import { AutocompleteFormatVerpackung } from '../auftragserfassung/adresse/search/AutocompleteFormatVerpackung';
import { AutocompleteFormatGefahrgutklasseUnnr } from '../auftragserfassung/adresse/search/AutocompleteFormatGefahrgutklasseUnnr';
import { AutocompleteFormatGefahrgutklasse } from '../auftragserfassung/adresse/search/AutocompleteFormatGefahrgutklasse';

export const initGefahrgutTableConfigGerstlauer = (
  searchVerpackungen: (rowIndex: number, value: string) => void,
  searchGefahrgutklassen: (rowIndex: number, text: string) => void,
  searchUnnr: (rowIndex: number, value: string) => void
  // setGefahrgutklasseFromUnnr: (rowIndex: number) => void,
  // setUnnrFromGefahrgutklasse: (rowIndex: number) => void
): TableConfig => {
  return [
    {
      id: 1,
      columnName: 'Nr. ',
      attributName: 'laufendeNummer',
      valueType: 'button',
    },
    {
      id: 2,
      columnName: 'UNNR *',
      attributName: 'gefahrgutUnnr',
      valueType: 'string',
      hierarchicalAttributename: 'unnr',
      autoCompleteFormat: AutocompleteFormatGefahrgutklasseUnnr,
      autoCompleteGetter: searchUnnr,
      maxWidth: '90',
    },
    {
      id: 3,
      columnName: 'Gefahrgutbezeichnung *',
      attributName: 'gefahrgutklasse',
      valueType: 'string',
      hierarchicalAttributename: 'bezeichnung',
      autoCompleteFormat: AutocompleteFormatGefahrgutklasse,
      autoCompleteGetter: searchGefahrgutklassen,
      minWidth: '400',
    },
    {
      id: 4,
      columnName: 'Auslöser',
      attributName: 'gefahrgutausloeser',
      valueType: 'string',
    },
    {
      id: 5,
      columnName: 'Anzahl *',
      attributName: 'anzahl',
      valueType: 'number',
    },
    {
      id: 6,
      columnName: 'Verpackung *',
      attributName: 'verpackung',
      valueType: 'string',
      hierarchicalAttributename: 'langBezeichnung',
      autoCompleteFormat: AutocompleteFormatVerpackung,
      autoCompleteGetter: searchVerpackungen,
    },
    {
      id: 7,
      columnName: 'Netto-Gewicht',
      attributName: 'nettoGewicht',
      valueType: 'float',
    },
    {
      id: 8,
      columnName: 'Brutto-Gewicht *',
      attributName: 'bruttoGewicht',
      valueType: 'float',
    },
    {
      id: 9,
      columnName: 'Liter',
      attributName: 'liter',
      valueType: 'float',
    },
    {
      id: 10,
      columnName: 'Explosivmasse',
      attributName: 'nettoexplosivmasse',
      valueType: 'float',
    },
    {
      id: 11,
      columnName: 'Begrenzte Menge',
      attributName: 'begrenztemenge',
      valueType: 'slidercheckbox',
    },
    {
      id: 12,
      columnName: 'Sondervorschrift (SV)',
      attributName: 'gefahrgutklasse',
      hierarchicalAttributename: 'sondervorschrift',
      valueType: 'string',
      readonly: true,
    },
    {
      id: 13,
      columnName: 'Vpcode.',
      attributName: 'gefahrgutklasse',
      hierarchicalAttributename: 'verpackungscode',
      valueType: 'string',
      readonly: true,
    },
    {
      id: 14,
      columnName: 'Gefahrzettel',
      attributName: 'gefahrgutklasse',
      hierarchicalAttributename: 'gefahrzettel',
      valueType: 'string',
      readonly: true,
    },
    {
      id: 15,
      columnName: 'Klasse',
      attributName: 'gefahrgutklasse',
      hierarchicalAttributename: 'klasse',
      valueType: 'string',
      readonly: true,
    },
    {
      id: 16,
      columnName: 'Klassif.',
      attributName: 'gefahrgutklasse',
      hierarchicalAttributename: 'klassifizierung',
      valueType: 'string',
      readonly: true,
    },
    {
      id: 17,
      columnName: 'Umweltgefährdend',
      attributName: 'umweltgefaehrdend',
      valueType: 'slidercheckbox',
    },
    /*{  OBSOLED bei Gerstlauer
      id: 18,
      columnName: 'Abfall',
      attributName: 'gefahrgutklasse',
      hierarchicalAttributename: 'abfall',
      valueType: 'slidercheckbox',
      readonly: true,
    },*/
    {
      id: 18,
      columnName: 'Version',
      attributName: 'gefahrgutklasse',
      hierarchicalAttributename: 'version',
      valueType: 'string',
      readonly: true,
    },
  ];
};
